import { collection, doc, setDoc, query, onSnapshot, serverTimestamp, orderBy, limit } from 'firebase/firestore';
import { db, sanitizeFirestoreData } from './firebase';

export interface ActivityLogItem {
  id: string;
  type: 'Payment Created' | 'Payment Completed' | 'Payment Failed' | 'Order Created' | 'Refund Issued' | 'Download Granted' | 'Invoice Generated' | 'Status Changed' | 'Manual Payment Submitted' | 'Manual Payment Approved' | 'Manual Payment Rejected' | 'Manual Payment Cancelled' | string;
  orderId?: string;
  customerName?: string;
  amount?: number;
  details: string;
  timestamp: string;
  ipAddress?: string;
}

const LOGS_COLLECTION = 'activity_logs';

export function subscribeToActivityLogs(onUpdate: (logs: ActivityLogItem[]) => void) {
  try {
    const q = query(collection(db, LOGS_COLLECTION), orderBy('timestamp', 'desc'), limit(100));
    return onSnapshot(q, (snapshot) => {
      const logs: ActivityLogItem[] = [];
      snapshot.forEach((docSnap) => {
        logs.push({ id: docSnap.id, ...docSnap.data() } as ActivityLogItem);
      });
      onUpdate(logs);
    }, (err) => {
      console.warn('Activity logs snapshot error:', err);
    });
  } catch (e) {
    console.warn('Subscribe activity logs error:', e);
    return () => {};
  }
}

export async function logActivityToFirestore(log: Omit<ActivityLogItem, 'id' | 'timestamp'>): Promise<void> {
  try {
    const logId = `log-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
    const fullLog: ActivityLogItem = {
      ...log,
      id: logId,
      timestamp: new Date().toISOString()
    };
    const payload = sanitizeFirestoreData({
      ...fullLog,
      createdAt: serverTimestamp()
    });
    await setDoc(doc(db, LOGS_COLLECTION, logId), payload);
  } catch (err) {
    console.error('Error logging activity to Firestore:', err);
  }
}

